<ifc-base-dialog [title]="'Re-amortize ' + (data?.loanNumber || '') + '?'"
                 [actions]="actions"
                 (actionClicked)="onActionClicked($event)">
  <ng-template #content>
    <div class="content">
      <div fxLayout="row wrap" fxFlex="100">
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="50" class="layout padding-vertical-md">
          <div>{{(data?.paymentAmount | currency) || 'Null'}}</div>
          <div class="mat-caption">Payment Amount</div>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="50" class="layout padding-vertical-md">
          <div>{{(data?.paymentDueDate | date: 'mediumDate') || 'Null'}}</div>
          <div class="mat-caption">Next payment due date</div>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="50" class="layout padding-vertical-md">
          <div>{{(data?.numberOfPaymentsLeft) || 'Null'}}</div>
          <div class="mat-caption">Number of payments left</div>
        </div>
      </div>
    </div>
  </ng-template>
</ifc-base-dialog>
